const modalButtonSelector = 'data-open-modal';
const modalElementSelector = 'data-modal';
const modalCloseSelector = 'data-close-modal';

const body = document.querySelector('body');

// Opening modals
document.querySelectorAll(`[${modalButtonSelector}]`)
    .forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector(`[${modalElementSelector}='${btn.getAttribute(modalButtonSelector)}']`)
            .classList.remove('hidden');
        body.classList.add('overflow-hidden');

        return false;
    }));

// Closing modals
document.querySelectorAll(`[${modalElementSelector}]`)
    .forEach((modal) => modal.addEventListener('click', (e) => {
        // Neither overlay, nor close button clicked -> do nothing
        if (e.target.getAttribute(modalCloseSelector) === null && e.target.getAttribute(modalElementSelector) === null) {
            return true;
        }

        e.preventDefault();

        modal.classList.add('hidden');
        body.classList.remove('overflow-hidden');

        return false;
    }));
